module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div\n    class="col-12 col-md-6 col-lg-12 col-xxl-6 d-flex flex-column property-listing separator '+
((__t=( featured ? 'featured px-0' : '' ))==null?'':__t)+
'"\n    data-location="'+
((__t=( structure.location.id ))==null?'':__t)+
'"\n    data-structure-type="'+
((__t=( structure.structure_type ))==null?'':__t)+
'"\n>\n    ';
 if (featured) { 
__p+='\n    <div class="heading px-3">'+
((__t=( t('featured') ))==null?'':__t)+
'</div>\n    ';
 } 
__p+='\n    <div class="order-lg-2 '+
((__t=( featured ? 'px-3' : '' ))==null?'':__t)+
'">\n        <div class="thumbnail">\n            <a href="'+
((__t=( cardTitleUrl ))==null?'':__t)+
'">\n                ';
 if (coverphoto) { 
__p+='\n                <picture>\n                    <source\n                        type="image/webp"\n                        media="(min-width: 992px)"\n                        data-srcset="'+
((__t=( coverphoto ))==null?'':__t)+
'?w=450&h=338&f=webp"\n                    />\n                    <source\n                        type="image/webp"\n                        media="(min-width: 768px)"\n                        data-srcset="'+
((__t=( coverphoto ))==null?'':__t)+
'?w=690&h=518&f=webp"\n                    />\n                    <source\n                        type="image/webp"\n                        media="(min-width: 576px)"\n                        data-srcset="'+
((__t=( coverphoto ))==null?'':__t)+
'?w=510&h=383&f=webp"\n                    />\n                    <source\n                        type="image/webp"\n                        data-srcset="'+
((__t=( coverphoto ))==null?'':__t)+
'?w=575&h=431&f=webp"\n                    />\n                    <source\n                        media="(min-width: 992px)"\n                        data-srcset="'+
((__t=( coverphoto ))==null?'':__t)+
'?w=450&h=338&f=jpg"\n                    />\n                    <source\n                        media="(min-width: 768px)"\n                        data-srcset="'+
((__t=( coverphoto ))==null?'':__t)+
'?w=690&h=518&f=jpg"\n                    />\n                    <source\n                        media="(min-width: 576px)"\n                        data-srcset="'+
((__t=( coverphoto ))==null?'':__t)+
'?w=510&h=383&f=jpg"\n                    />\n                    <img\n                        class="lazyload w-100 h-100"\n                        data-src="'+
((__t=( coverphoto ))==null?'':__t)+
'?w=575&h=431&f=jpg"\n                        src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"\n                    />\n                </picture>\n                ';
 } else { 
__p+='\n                <div class="cntr-photo-placeholder">\n                    <div class="photo-placeholder text-center">\n                        <i class="fa fa-2x fa-lock"></i>\n                        <p class="mt-3">Contact for more <br />information</p>\n                    </div>\n                </div>\n                ';
 } 
__p+='\n            </a>\n        </div>\n    </div>\n\n    <div class="order-lg-1 '+
((__t=( featured ? 'px-3' : '' ))==null?'':__t)+
'">\n        <h2 class="title mt-3">\n            <a href="'+
((__t=( cardTitleUrl ))==null?'':__t)+
'">'+
((__t=( title ))==null?'':__t)+
'</a>\n        </h2>\n    </div>\n\n    <div class="mt-3 order-lg-3 '+
((__t=( featured ? 'px-3' : '' ))==null?'':__t)+
'">\n        <p class="address">'+
((__t=( address ))==null?'':__t)+
'</p>\n\n        <div class="row">\n            <p class="train-station col-6">\n                <strong>'+
((__t=( t('nearest_station') ))==null?'':__t)+
':</strong><br />\n                '+
((__t=( trainInfo(structure, 0) ))==null?'':__t)+
'<br />\n                '+
((__t=( trainInfo(structure, 1) ))==null?'':__t)+
'\n            </p>\n\n            ';
 if (structure.structure_type === 'building' ||
            structure.structure_type === 'house') { 
__p+='\n            <p class="year-built col-6">\n                <strong>'+
((__t=( t('year_built') ))==null?'':__t)+
':</strong> '+
((__t=(
                structure.completion_year ))==null?'':__t)+
'\n            </p>\n            ';
 } else if (structure.structure_type === 'land') { 
__p+='\n            <p class="land-right col-6">\n                <strong>'+
((__t=( t('Land right') ))==null?'':__t)+
':</strong> '+
((__t=(
                structure.x_land_right ))==null?'':__t)+
'\n            </p>\n            ';
 } 
__p+='\n        </div>\n    </div>\n\n    <div class="order-lg-4 '+
((__t=( featured ? 'px-3' : '' ))==null?'':__t)+
'">\n        <table class="table table-sm table-hover">\n            ';
 if (structure.structure_type === 'building' &&
            _.isArray(structure.units)) { 
__p+='\n            <thead>\n                <tr>\n                    <th>'+
((__t=( t('title_unit') ))==null?'':__t)+
'</th>\n                    <th>'+
((__t=( t('title_bedrooms') ))==null?'':__t)+
'</th>\n                    <th>'+
((__t=( t('title_bathrooms') ))==null?'':__t)+
'</th>\n                    <th>'+
((__t=( t('title_size') ))==null?'':__t)+
'</th>\n                    ';
 if (section === 'rent') { 
__p+='\n                    <th>'+
((__t=( t('title_rent') ))==null?'':__t)+
'</th>\n                    ';
 } else if (section === 'buy') { 
__p+='\n                    <th>'+
((__t=( t('title_price') ))==null?'':__t)+
'</th>\n                    ';
 } else if (section === 'short-term') { 
__p+='\n                    <th>'+
((__t=( t('title_monthly_rate') ))==null?'':__t)+
'</th>\n                    ';
 } 
__p+='\n                    <th></th>\n                </tr>\n            </thead>\n            <tbody>\n                ';
 for (const unit of structure.units) { 
__p+='\n                <tr>\n                    ';
 if (section === 'short-term') { 
__p+='\n                    <td>'+
((__t=( unit.room_no ))==null?'':__t)+
'</td>\n                    ';
 } else { 
__p+='\n                    <td>\n                        '+
((__t=( language === 'en' ? unit.room_no : unit.floor_no +
                        'F' ))==null?'':__t)+
'\n                    </td>\n                    ';
 } 
__p+='\n                    <td>'+
((__t=( bedroomNo(unit) ))==null?'':__t)+
'</td>\n                    <td>'+
((__t=( unit.bathroom_no ))==null?'':__t)+
'</td>\n                    <td>\n                        '+
((__t=( getSize(unit) ))==null?'':__t)+
' '+
((__t=( language === 'en' ? 'm&sup2;' :
                        '' ))==null?'':__t)+
'\n                    </td>\n                    <td class="cost">\n                        '+
((__t=( section === 'rent' ? moneyFormat(getCost(unit)) :
                        moneyFormat(getCost(unit), true) ))==null?'':__t)+
' ';
 if
                        (unit.starting_price) { 
__p+='~';
 } 
__p+='\n                    </td>\n                    <td>\n                        <a\n                            href="'+
((__t=( unitDetailsUrl(structure, unit, 'properties', key) ))==null?'':__t)+
'"\n                            class="btn text-uppercase btn-primary btn-view"\n                            >'+
((__t=( t('view') ))==null?'':__t)+
'</a\n                        >\n                    </td>\n                </tr>\n                ';
 } 
__p+='\n            </tbody>\n            ';
 } else if (structure.structure_type === 'house' &&
            structure.unit) { 
__p+='\n            <thead>\n                <tr>\n                    <th>'+
((__t=( t('title_type') ))==null?'':__t)+
'</th>\n                    <th>'+
((__t=( t('title_bedrooms') ))==null?'':__t)+
'</th>\n                    <th>'+
((__t=( t('title_bathrooms') ))==null?'':__t)+
'</th>\n                    <th>'+
((__t=( t('title_size') ))==null?'':__t)+
'</th>\n                    ';
 if (section === 'rent') { 
__p+='\n                    <th>'+
((__t=( t('title_rent') ))==null?'':__t)+
'</th>\n                    ';
 } else if (section === 'buy') { 
__p+='\n                    <th>'+
((__t=( t('title_price') ))==null?'':__t)+
'</th>\n                    ';
 } else if (section === 'short-term') { 
__p+='\n                    <th>'+
((__t=( t('title_monthly_rate') ))==null?'':__t)+
'</th>\n                    ';
 } 
__p+='\n                    <th></th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr>\n                    <td>'+
((__t=( structure_type ))==null?'':__t)+
'</td>\n                    <td>'+
((__t=( bedroomNo(structure.unit) ))==null?'':__t)+
'</td>\n                    <td>'+
((__t=( structure.unit.bathroom_no ))==null?'':__t)+
'</td>\n                    <td>\n                        '+
((__t=( getSize(structure.unit) ))==null?'':__t)+
' '+
((__t=( language === 'en' ?
                        'm&sup2;' : '' ))==null?'':__t)+
'\n                    </td>\n                    <td class="cost">\n                        '+
((__t=( section === 'rent' ?
                        moneyFormat(getCost(structure.unit)) :
                        moneyFormat(getCost(structure.unit), true) ))==null?'':__t)+
' ';
 if
                        (structure.unit.starting_price) { 
__p+='~';
 } 
__p+='\n                    </td>\n                    <td>\n                        <a\n                            href="'+
((__t=( unitDetailsUrl(structure, structure.unit, 'properties', key) ))==null?'':__t)+
'"\n                            class="btn text-uppercase btn-primary btn-view"\n                            >'+
((__t=( t('view') ))==null?'':__t)+
'</a\n                        >\n                    </td>\n                </tr>\n            </tbody>\n            ';
 } else if (structure.structure_type === 'land') { 
__p+='\n            <thead>\n                <tr>\n                    <th>'+
((__t=( t('title_type') ))==null?'':__t)+
'</th>\n                    <th>'+
((__t=( t('title_land_size') ))==null?'':__t)+
'</th>\n                    ';
 if (section === 'rent') { 
__p+='\n                    <th>'+
((__t=( t('title_rent') ))==null?'':__t)+
'</th>\n                    ';
 } else if (section === 'buy') { 
__p+='\n                    <th>'+
((__t=( t('title_price') ))==null?'':__t)+
'</th>\n                    ';
 } else if (section === 'short-term') { 
__p+='\n                    <th>'+
((__t=( t('title_monthly_rate') ))==null?'':__t)+
'</th>\n                    ';
 } 
__p+='\n                    <th></th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr>\n                    <td>'+
((__t=( structure_type ))==null?'':__t)+
'</td>\n                    <td>\n                        '+
((__t=( getSize(structure) ))==null?'':__t)+
' '+
((__t=( language === 'en' ?
                        'm&sup2;' : '' ))==null?'':__t)+
'\n                    </td>\n                    <td class="cost">\n                        '+
((__t=( section === 'rent' ? moneyFormat(getCost(structure))
                        : moneyFormat(getCost(structure), true) ))==null?'':__t)+
' ';
 if
                        (structure.starting_price) { 
__p+='~';
 } 
__p+='\n                    </td>\n                    <td>\n                        <a\n                            href="'+
((__t=( structureDetailsUrl(structure, 'properties', key) ))==null?'':__t)+
'"\n                            class="btn text-uppercase btn-primary btn-view"\n                            >'+
((__t=( t('view') ))==null?'':__t)+
'</a\n                        >\n                    </td>\n                </tr>\n            </tbody>\n            ';
 } else if (structure.structure_type === 'building') { 
__p+='\n            <thead>\n                <tr>\n                    <th>'+
((__t=( t('title_type') ))==null?'':__t)+
'</th>\n                    <th>'+
((__t=( t('title_building_size') ))==null?'':__t)+
'</th>\n                    ';
 if (section === 'rent') { 
__p+='\n                    <th>'+
((__t=( t('title_rent') ))==null?'':__t)+
'</th>\n                    ';
 } else if (section === 'buy') { 
__p+='\n                    <th>'+
((__t=( t('title_price') ))==null?'':__t)+
'</th>\n                    ';
 } else if (section === 'short-term') { 
__p+='\n                    <th>'+
((__t=( t('title_monthly_rate') ))==null?'':__t)+
'</th>\n                    ';
 } 
__p+='\n                    <th></th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr>\n                    <td>'+
((__t=( structure_type ))==null?'':__t)+
'</td>\n                    <td>\n                        '+
((__t=( getSize(structure) ))==null?'':__t)+
' '+
((__t=( language === 'en' ?
                        'm&sup2;' : '' ))==null?'':__t)+
'\n                    </td>\n                    <td class="cost">\n                        '+
((__t=( section === 'rent' ? moneyFormat(getCost(structure))
                        : moneyFormat(getCost(structure), true) ))==null?'':__t)+
' ';
 if
                        (structure.starting_price) { 
__p+='~';
 } 
__p+='\n                    </td>\n                    <td>\n                        <a\n                            href="'+
((__t=( structureDetailsUrl(structure, 'properties', key) ))==null?'':__t)+
'"\n                            class="btn text-uppercase btn-primary btn-view"\n                            >'+
((__t=( t('view') ))==null?'':__t)+
'</a\n                        >\n                    </td>\n                </tr>\n            </tbody>\n            ';
 } else { console.warn('Malformed property: ', structure); } 
__p+='\n        </table>\n    </div>\n</div>\n';
}
return __p;
};
